import { useTranslation } from 'next-i18next/pages';
import React from 'react';

import useCurrentLang from '@/hooks/apps/useCurrentLang';

import { HOME_FAQ_BY_LOCALE } from '@/data/shared/homeFaq';

import { SolutionFaqSection } from '@/components/apps/pages/solution/shared/SolutionFaqSection';

/**
 * ### HomeFaqSection
 *
 * Places the shared FAQ section on the home page with the home copy, which is
 * the same list the home route emits as FAQPage structured data, so the
 * rendered questions and the schema can never drift. The copy is written per
 * language in the data module, so the entries are picked by the routed locale
 * rather than translated through i18n keys; only the section heading goes
 * through i18n.
 *
 * The section closes the page, under the client logo wall and above the
 * footer. The footer stands on the black ground, so the section takes the dark
 * tone and carries the light logo band into it; a light band here would leave
 * a seam right where the page ends.
 *
 * @returns The rendered FAQ section element
 * @see {@link HOME_FAQ_BY_LOCALE} The copy rendered here
 * @see {@link SolutionFaqSection} The shared section this configures
 */
export function HomeFaqSection() {
  const { t } = useTranslation('common');
  const currentLang = useCurrentLang();

  return (
    <SolutionFaqSection
      tone="dark"
      analyticsSectionId="home_faq"
      title={t('자주 묻는 질문')}
      items={HOME_FAQ_BY_LOCALE[currentLang]}
    />
  );
}
